<template>
  <div
    v-if="TOOLTIPS_VISIBLE"
    class="kd-tooltips"
    @click="hide"
  >

    <!-- tooltips are managed by v-tooltip, see also tooltip functions in vuex -->
    <!-- the texts for each tooltip are in tooltip-texts.js -->
  </div>  
</template>

<script>
import { mapGetters } from 'vuex';

import {
  TOOLTIPS_VISIBLE,
  TOOLTIPS,
} from '@/store/getter-types';

import {
  SET_TOOLTIPS_TO_NOT_VISIBLE,
} from '@/store/mutation-types';

export default {
  computed: {
    ...mapGetters([
      TOOLTIPS_VISIBLE,
    ]),
  },
  methods: {
    hide() {
      this.$store.commit(SET_TOOLTIPS_TO_NOT_VISIBLE);
    },
  },
}
</script>

<style lang="scss">
  .kd-tooltips {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);

    .kd--print & { display: none !important; }
  }
</style>
